<template>
  <StellaLink
    v-if="!user.isLoggedIn"
    :to="{ name: 'signup', query: { sp_ft2: 'true' } }"
    class="border-grey-20"
    v-track="'Join Spoak Clicked'"
    v-track-props="trackingData"
  >
    <StellaButton :type="type" size="sm">
      <slot>Join</slot>
    </StellaButton>
  </StellaLink>
</template>

<script lang="ts" setup>
import type { TrackingData } from '../core/tracking'
import type { StellaButtonType } from '../stella/types'
import { useUser } from '/@/data/user'

const { type = 'tertiary', trackingData } = defineProps<{
  type?: StellaButtonType
  trackingData: TrackingData
}>()

const user = useUser()
</script>
